import "./FormField.scss";
import { Form } from 'react-bootstrap';

const FormSelect = (props) => {
  const { label, placeholder, optionList, value, setFunc, disabled, showLabel, item, keyName } = props;

  return (
      <>
        <Form.Group className="mb-3" controlId="formBasicPassword">
          {showLabel && (<Form.Label>{label}</Form.Label>)}
          <Form.Select 
            value={value}
            disabled={disabled}
            onChange={(event) => setFunc(event.target.value, item, keyName)}
          >
            <option value="">{placeholder || 'Select'}</option>
            {optionList && optionList.map((item, index) => {
              return (
                <option key={`${item.label}-${item.id}`} value={item.name}>{item.label}</option>
              );
            })}
            {!optionList && value && (
              <option value={value}>{value}</option>
            )}
          </Form.Select>
        </Form.Group>
      </>
  );
};

export default FormSelect;
